module.exports = __webpack_public_path__ + "static/media/wallpaper-2.fa26fa45.jpg";